import * as Vlab from 'vlab-frontend-components';
import React from 'react';
import Translator from '../../components/i18n/translator';
import { useTranslation } from 'react-i18next';

export default function SidebarItems({
  open,
  menuSelected,
  handleMenuItemClick,
  navigateToUpsell,
  hasDicom,
  hasMedicalReports,
  hasNotification,
  hasMarketing,
  hasFinancial,
  hasStorage,
  isAdmin,
  isProfilePermissionsResolved,
  hasOnlyBookletPolicy,
  country,
  setCountry,
  changeLanguage,
}: {
  open: boolean,
  menuSelected: any,
  handleMenuItemClick: any,
  navigateToUpsell: (feature: string) => void,
  hasDicom: boolean,
  hasMedicalReports: boolean,
  hasNotification: boolean,
  hasMarketing: boolean,
  hasFinancial: boolean,
  hasStorage: boolean,
  isAdmin: boolean,
  isProfilePermissionsResolved: boolean,
  hasOnlyBookletPolicy: boolean,
  country: string,
  setCountry: any,
  changeLanguage: any
}) {
  const { t } = useTranslation()

  const upsellLabel = (
    <span style={{ color: '#0166FF', marginLeft: '4px', fontSize: '12px', fontWeight: 500 }}>
      {t('menu.learnMore')}
    </span>
  )

  const upsellStyle = { display: 'inline-flex' as const, alignItems: 'center' as const }

  return (
    <>

      <Vlab.MenuList onClick={() => null}>
        <div className='h-[calc(100vh-200px)] overflow-y-auto !overflow-x-hidden'>
          <Vlab.MenuItem
            open={open}
            icon={<Vlab.VGreyIcon />}
            label={<Vlab.Typography color="greyDark" type="subheadingS">Insights</Vlab.Typography>}
            onClick={() => handleMenuItemClick(0)}
            isSelected={menuSelected.vbabyInsights}

          />

          <Vlab.MenuItem
            open={open}
            icon={<Vlab.ExamIcon />}
            label={
              <Vlab.Typography color="greyDark" type="subheadingS" style={isProfilePermissionsResolved && hasOnlyBookletPolicy ? upsellStyle : undefined}>
                <Translator path="menu.examsTitle" />
                {isProfilePermissionsResolved && hasOnlyBookletPolicy && upsellLabel}
              </Vlab.Typography>
            }
            onClick={() => isProfilePermissionsResolved ? (hasOnlyBookletPolicy ? navigateToUpsell('recordings') : handleMenuItemClick(1)) : undefined}
            isSelected={menuSelected.vbabyExams}
          />
          
          {/* Não esquecer */}
          <Vlab.MenuItem
            open={open}
            icon={<Vlab.ImageIcon />}
            label={
              <Vlab.Typography color="greyDark" type="subheadingS" style={isProfilePermissionsResolved && !hasDicom ? upsellStyle : undefined}>
                <Translator path="menu.dicomTitle" />
                {isProfilePermissionsResolved && !hasDicom && upsellLabel}
              </Vlab.Typography>
            }
            onClick={() => isProfilePermissionsResolved ? (hasDicom ? handleMenuItemClick(2) : navigateToUpsell('images')) : undefined}
            isSelected={menuSelected.dicom}
          />

          <Vlab.MenuItem
            open={open}
            icon={<Vlab.ReportIcon />}
            label={
              <Vlab.Typography color="greyDark" type="subheadingS" style={isProfilePermissionsResolved && !hasMedicalReports ? upsellStyle : undefined}>
                <Translator path="menu.medicalReportsTitle" />
                {isProfilePermissionsResolved && !hasMedicalReports && upsellLabel}
              </Vlab.Typography>
            }
            onClick={() => isProfilePermissionsResolved ? (hasMedicalReports ? handleMenuItemClick(3) : navigateToUpsell('results')) : undefined}
            isSelected={menuSelected.medicalReports}
          />

          {hasNotification && <Vlab.MenuItem
            open={open}
            icon={<Vlab.BellIcon height={18} width={16} />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.communicationTitle" /></Vlab.Typography>}
            onClick={() => handleMenuItemClick(11)}
            isSelected={menuSelected.communication}
          />}

          {hasMarketing && <Vlab.MenuItem
            open={open}
            icon={<Vlab.MarketingIcon />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.marketingTitle" /></Vlab.Typography>}
            onClick={() => handleMenuItemClick(5)}
            isSelected={menuSelected.marketing}
          />}

          {hasStorage && <Vlab.MenuItem
            open={open}
            icon={<Vlab.CloudContainedIcon width={16} height={18} />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.storageTitle" /></Vlab.Typography>}
            onClick={() => handleMenuItemClick(14)}
            isSelected={menuSelected.storage}
          />}

          {hasFinancial && <Vlab.MenuItem
            open={open}
            icon={<Vlab.MoneyIcon width={16} height={18} />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.financialTitle" /></Vlab.Typography>}
            onClick={() => handleMenuItemClick(13)}
            isSelected={menuSelected.financial}
          />}

          <Vlab.MenuItem
            open={open}
            icon={<Vlab.ChartIcon />}
            label={
              <Vlab.Typography color="greyDark" type="subheadingS" style={isProfilePermissionsResolved && hasOnlyBookletPolicy ? upsellStyle : undefined}>
                <Translator path="menu.reportsTitle" />
                {isProfilePermissionsResolved && hasOnlyBookletPolicy && upsellLabel}
              </Vlab.Typography>
            }
            onClick={() => isProfilePermissionsResolved ? (hasOnlyBookletPolicy ? navigateToUpsell('reports') : handleMenuItemClick(4)) : undefined}
            isSelected={menuSelected.videoReports}
          />

          <Vlab.MenuItem
            open={open}
            icon={<Vlab.PencilIcon />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.customizationTitle" /></Vlab.Typography>}
            onClick={() => handleMenuItemClick(4)}
            isSelected={menuSelected.customizations}
            divider={true}
          />

          {isAdmin && <Vlab.MenuItem
            open={open}
            icon={<Vlab.HookIcon />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.hooksFleuryTitle" /></Vlab.Typography>}
            adminColor="rgb(245, 0, 87)"
            onClick={() => handleMenuItemClick(6)}
            isSelected={menuSelected.hooksFleury}
          />}

          {isAdmin && <Vlab.MenuItem
            open={open}
            icon={<Vlab.ReprocessIcon />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.mp4ReprocessTitle" /></Vlab.Typography>}
            adminColor='rgb(245, 0, 87)'
            onClick={() => handleMenuItemClick(7)}
            isSelected={menuSelected.mp4Reprocess}
            divider={true}
          />}

          <Vlab.MenuItem
            open={open}
            icon={<Vlab.GooutIcon />}
            label={<Vlab.Typography color="greyDark" type="subheadingS"><Translator path="menu.goOutTitle" /></Vlab.Typography>}
            onClick={() => handleMenuItemClick(9)}
            isSelected={menuSelected.logout}
            divider={true}
          />
        </div>
      </Vlab.MenuList>

      <Vlab.MenuFooter open={open}>
        {open ? (
          <>
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px'
              }}
            >
              <div style={{
                width: 'calc(100% - 24px)',
                padding: '4px 0',
              }}>
                <Vlab.FlagSelect
                  selected={country.toUpperCase()}
                  onSelect={(selectedCountry: any) => {
                    setCountry(selectedCountry);
                    changeLanguage(selectedCountry);
                  }}
                  countries={["US", "ES", "BR"]}
                  maxHeight='200px'
                />
              </div>
            </div>
            <Vlab.MenuFooterItem
              button={
                <Vlab.PlatformButton
                  variant="secondary"
                  name={t('menu.platform')}
                  onClick={() => handleMenuItemClick(9)}
                />
              }

            />
          </>
        ) : (
          <Vlab.MenuFooterItem button={<Vlab.ButtonV variant="secondary" onClick={() => handleMenuItemClick(0)}></Vlab.ButtonV>} />
        )}
      </Vlab.MenuFooter>
    </>
  )
}